import React, { FC, ReactNode } from "react";
import CustomTooltip from "../../../CustomTooltip";
import { StyledIconButton } from "../../styled";

type Props = {
  onClick?: () => void;
  Icon: ReactNode;
  isHighlighted?: boolean;
  isTooltip?: boolean;
  tooltipTitle?: ReactNode;
};

const ToolbarItem: FC<Props> = ({
  onClick,
  Icon,
  isHighlighted,
  isTooltip,
  tooltipTitle,
}) => {
  if (isTooltip) {
    return <CustomTooltip title={tooltipTitle}>{Icon}</CustomTooltip>;
  }

  return (
    <StyledIconButton
      onMouseDown={(e) => {
        e.preventDefault();
        onClick?.();
      }}
      isHighlighted={isHighlighted}
    >
      {Icon}
    </StyledIconButton>
  );
};

export default ToolbarItem;
